import React, { useContext } from "react";
import { CalendarDays, CircleChevronUp } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { GlobalContext } from "@/context/globalContext";

const SelectDates = () => {
  const searchParams = useSearchParams();
  const { mobileBar, setMobileBar } = useContext(GlobalContext);
  return (
    <div className="fixed z-10 w-full p-2 text-sm leading-4 bottom-16">
      <div
        onClick={() => {
          mobileBar === "reservationForm"
            ? setMobileBar(false)
            : setMobileBar("reservationForm");
        }}
        className="flex items-center justify-between px-5 py-4 text-white lg:hidden bg-detailBottomGradient shadow-detailBottomShadow rounded-2xl"
      >
        <div className="flex items-center gap-4">
          <CalendarDays size={22} />
          <strong>
            {searchParams.get("start") || searchParams.get("end")
              ? "Ön Rezervasyon Talebi"
              : "Tarih Seçiniz"}
          </strong>
        </div>
        <div className="cursor-pointer">
          <CircleChevronUp size={22} />
        </div>
      </div>
    </div>
  );
};

export default SelectDates;
